<template>
<form @submit.prevent="post" class="ui form loginForm" :class="{'error': form.hasErrors()}">
  
  <div class="ui two column middle very relaxed stackable grid">
    <div class="center aligned column loginForm__column">
      <h2 class="loginForm__sectionTitle">メールアドレスでログイン</h2>
      <app-message :msg="form.appMessage"></app-message>
      <div class="ui form" :class="{'warning': form.hasErrors()}">
        <div class="field">
          <div class="ui left icon input">
            <input v-model="form.model.login_id" type="text" :placeholder="loginIdLabel">
            <i class="envelope icon"></i>
          </div>
          <validation-message :form="form" :field="'login_id'"></validation-message>
        </div>
        <div class="field">
          <div class="ui left icon input">
            <input v-model="form.model.password" type="password" placeholder="パスワード">
            <i class="lock icon"></i>
          </div>
          <validation-message :form="form" :field="'password'"></validation-message>
        </div>
        <div class="field">
          <button type="submit" class="ui fluid orange submit button" :class="{'loading disabled': form.waiting}">ログイン</button>
        </div>
        <div class="field">
          <a href="/reset_password_remind" class="loginForm__passwordReminderLink">パスワードがわからない方はこちら</a>
        </div>
      </div>
    </div>
    <!-- semantic ui bug https://github.com/Semantic-Org/Semantic-UI/issues/4342#issuecomment-326776812 -->
    <div style="position:relative; margin:0; padding:0;">
      <div class="ui vertical divider loginForm__sectionDivider">
        または
      </div>
    </div>
    <div class="center aligned column loginForm__column">
      <h2 class="loginForm__sectionTitle">SNSアカウントでログイン</h2>
      <div v-if="socialAuthErrorCode" class="ui negative message">
        <span v-if="socialAuthErrorCode === 'oauth'">
        SNSとの連携に失敗しました。
        </span>
        <span v-else-if="socialAuthErrorCode === 'duplicated'">
        SNSでご利用中のメールアドレスはすでに会員登録済みです。<br>
        左記のフォームにてログインしてください。
        </span>
      </div>
      <div class="ui form">
        <div class="field">
          <a href="/facebook/login">
            <button type="button" class="ui fluid large facebook button">
              <i class="facebook icon"></i>Facebookでログイン
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</form>
</template>

<script>
export default {
    props: {
        loginIdLabel: {
            type: String,
            required: true
        },
        role: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function() {
        return {
            form: this.createForm({
                login_id: this.query().login_id,
                redirect: this.query().redirect
            }),
            facebookLoading: false,
            socialAuthErrorCode: null,
        };
    },
    created: function() {
        this.socialAuthErrorCode = this.query().error;
    },
    methods: {
        post: function() {
            var roleContext = '';
            if (this.role) {
                roleContext += '/' + this.role
            }
            this.form.post(roleContext + '/api/login');
        }
    }
}
</script>
